class ReturnApi {
    /**
     * Create a new Return API instance..
     */
    constructor(response, vm, padrao = true, convert_data = false, refresh = true, hide_modal = true) {
        // Irá colocar o data diretamente no response
        if(convert_data)
        {
            response = response.data;
        }

        if(response.status==401)
        {
            window.location.replace("/?status=401");
        }

        // Ajustando loading e botao
        if(padrao)
        {
            vm.loading      = false;
            vm.isDisabled   = false;
        }

        // Controla o refresh da VUETABLE
        // Padrão será sempre efetuar Refresh caso status seja 200
        if((response.vuetable || response.vuetable==undefined) && (response.status==200 || response.httpStatus==200) && refresh)
        {
            if(vm.$refs.vuetable!=undefined)//grid
            {
                vm.$refs.vuetable.reload();
            }
            else if (vm.$parent.$refs.vuetable !=undefined)//Açao no grid q joga para um form
            {
                vm.$parent.$refs.vuetable.reload();
            }
            else if(vm.$parent.$parent.$parent.$refs.vuetable != undefined)//Açao no detalhes q joga para um form
            {
                vm.$parent.$parent.$parent.$refs.vuetable.reload();
            }
            else if(vm.$parent.$parent.$refs.vuetable != undefined)//Açao no detalhes q joga para um form
            {
                vm.$parent.$parent.$refs.vuetable.reload();
            }
        }

        // Caso não tenha o tipo da Message, sera success
        if(response.tp_message==undefined)
        {
            response.tp_message = 'success';
        }

        // Tipo 1 é Snotify
        if(response.type==1)
        {
            if(response.title != null){
                vm.title = response.title;
            }else{
                vm.title = "";
            }
            vm.$snotify[response.tp_message](response.message, vm.title);

            // Escondendo o Modal
            if(hide_modal) {
                // Escondendo o modal
                vm.showModal = false; // DEPRECATED REVISAR

                // Irá esconder todos os modais
                for (var property in vm.$refs) {
                    if (vm.$refs[property] != undefined) {
                        //var modal = vm.$refs[property];
                        if (property.search("modal") >= 0) {
                            vm.$refs[property].hide();
                        }
                    }
                }
            }
        }
        // 2 é Alert
        else if(response.type==2)
        {
            // Escondendo o Modal
            if(hide_modal) {
                vm.showModal = false; // DEPRECATED REVISAR

                // Irá esconder todos os modais
                for (var property in vm.$refs) {
                    if (vm.$refs[property] != undefined) {
                        //var modal = vm.$refs[property];
                        if (property.search("modal") >= 0) {
                            vm.$refs[property].hide();
                        }
                    }
                }
            }

            var obj = {
              isShown: true,
              title: response.title,
              message: response.message,
              type: response.tp_message,
              customCloseBtnText: "Fechar",
              onClose: this.onClose,
            }
            vm.$Simplert.open(obj);
        }
        // 3 Validação de formulario
        else if(response.type==3)
        {

        }
        // Nulo não apresenta nada
        else
        {

        }

        return true;
    }
}

export default ReturnApi;
